import gql from 'graphql-tag'

export const REGISTER_FCM_TOKEN = gql`
  mutation RegisterFCMToken($input: RegisterFCMTokenInput!) {
    registerFCMToken(input: $input) {
      isSuccessful
      message
      registerFCMToken {
        message
      }
    }
  }
`

export const UNREGISTER_FCM_TOKEN = gql`
  mutation UnregisterFCMToken($input: UnRegisterFCMTokenInput!) {
    unregisterFCMToken(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      unregisterFCMToken {
        message
      }
    }
  }
`
export const GET_FCM_TOKEN = gql`
  query GetFCMToken {
    getFCMToken {
      isSuccessful
      errorCode
      errorName
      message
      status
      getFCMToken {
        fcmToken
      }
    }
  }
`
export const STORE_FCM_TOKEN = gql`
  mutation StoreFCMToken($input: StoreFCMTokenInput!) {
    storeFCMToken(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      storeFCMToken {
        status
      }
    }
  }
`
